'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChatLocaleText } from "../chat/internals/ChatLocaleContext.js";
import { getDataAttributes } from "../internals/getDataAttributes.js";
import { useComposerContext } from "./internals/ComposerContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerSendButton = /*#__PURE__*/React.forwardRef(function ComposerSendButton(props, ref) {
  const {
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const composer = useComposerContext();
  const localeText = useChatLocaleText();
  const ownerState = {
    isSubmitting: composer.isSubmitting,
    hasValue: composer.hasValue,
    isStreaming: composer.isStreaming,
    attachmentCount: composer.attachmentCount,
    disabled: composer.disabled
  };
  const SendButton = slots?.sendButton ?? 'button';
  const rootProps = useSlotProps({
    elementType: SendButton,
    externalSlotProps: slotProps?.sendButton,
    externalForwardedProps: other,
    ownerState,
    additionalProps: _extends({
      ref
    }, getDataAttributes({
      isSubmitting: ownerState.isSubmitting,
      hasValue: ownerState.hasValue,
      isStreaming: ownerState.isStreaming,
      disabled: ownerState.disabled
    }))
  });
  return /*#__PURE__*/_jsx(SendButton, _extends({}, rootProps, {
    "aria-label": rootProps['aria-label'] ?? localeText.composerSendButtonLabel,
    disabled: Boolean(rootProps.disabled) || !ownerState.hasValue || ownerState.isStreaming || ownerState.disabled,
    type: rootProps.type ?? 'submit'
  }));
});
if (process.env.NODE_ENV !== "production") ComposerSendButton.displayName = "ComposerSendButton";